import React from 'react';
import PropTypes from 'prop-types';
import MaterialDivider from '@material-ui/core/Divider';

const Divider = ({
  color,
  customStyle,
  margin,
  marginBottom,
  marginTop,
}) => (
  <MaterialDivider
    style={customStyle || {
      backgroundColor: color || 'rgb(224, 224, 224)',
      marginBottom: marginBottom || margin,
      marginTop: marginTop || margin,
    }}
  />
);

Divider.propTypes = {
  color: PropTypes.string,
  customStyle: PropTypes.shape({}),
  margin: PropTypes.number,
  marginBottom: PropTypes.number,
  marginTop: PropTypes.number,
};

Divider.defaultProps = {
  color: null,
  customStyle: null,
  margin: 0,
  marginBottom: 10,
  marginTop: 10,
};

export default Divider;
